import { createSelector } from '@ngrx/store';
import { getPhysicalAddressState, PhysicalAddressState } from '../reducers';
import { DetailAddressState } from '../reducers/detail-address.reducer';
import { SuggestedAddressesState } from '../reducers/suggested-addresses.reducer';

export const getSuggestedAddressesState = createSelector(
  getPhysicalAddressState,
  (state: PhysicalAddressState) => state.autocomplete,
);

const getError = (state: SuggestedAddressesState | DetailAddressState) =>
  state.error;
const getLoading = (state: SuggestedAddressesState | DetailAddressState) =>
  state.loading;

export const getSuggestedAddresses = createSelector(
  getSuggestedAddressesState,
  (state: SuggestedAddressesState) => state.suggestedAddresses,
);

export const getSuggestedAddressesError = createSelector(
  getSuggestedAddressesState,
  getError,
);

export const getSuggestedAddressesLoading = createSelector(
  getSuggestedAddressesState,
  getLoading,
);

export const getDetailAddressState = createSelector(
  getPhysicalAddressState,
  (state: PhysicalAddressState) => state.metadata,
);

export const getDetailAddress = createSelector(
  getDetailAddressState,
  (state: DetailAddressState) => state.detailAddress,
);

export const getDetailAddressError = createSelector(
  getDetailAddressState,
  getError,
);

export const getDetailAddressLoading = createSelector(
  getDetailAddressState,
  getLoading,
);
